<script lang="ts">
import { gsap } from 'gsap'
import { defineComponent, onUnmounted } from 'vue'

import LayerGrid from '@/components/atoms/LayerGrid.vue'
export default defineComponent({
  name: 'LayerRandomGrid',
  components: {
    LayerGrid
  },
  setup (props, { attrs, slots, emit }) {
    let tl

    const onRefresh = (els) => {
      tl = gsap.timeline({ repeat: -1 })
      els.forEach(item => {
        const start = Math.random()
        tl.to(item, { autoAlpha: 1, duration: 0.02 }, start)
        tl.to(item, { autoAlpha: 0, duration: 0.02 }, start + Math.random())
      })
      tl.timeScale(0.8)
    }

    onUnmounted(() => tl?.kill())
    return {
      onRefresh
    }
  }
})
</script>

<template>
  <LayerGrid @refresh="onRefresh" />
</template>
